// import { Container } from 'components/Container/Container';
import styled from 'styled-components';

export const ContainerLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 1440px;
  height: 100vh;
`;

export const StuledContainer = styled.main`
  flex-grow: 3;
  box-sizing: border-box;
`;
